/**
 * Centralized route configuration for the application.
 * All routes are defined here to keep URLs in sync across the app.
 */

import { NavigationItem } from "../types/navigation";

export const ROUTES = {
    // Main pages
    HOME: "/",

    // Learn pages
    LEARN: {
        START_HERE: "/Learn",
        INTERVALS: "/Learn/Intervals",
        CHORDS: "/Learn/Chords",
        PROGRESSIONS: "/Learn/Progressions",
        MELODIES: "/Learn/Melodies",
    },

    // Drill pages
    DRILL: {
        INTERVALS: "/Drill/Intervals",
        CHORDS: "/Drill/Chords",
        PROGRESSIONS: "/Drill/Progressions",
        MELODIES: "/Drill/Melodies",
    },

    // Demo pages
    DEMOS: {
        SOUND: "/Demos/Sound",
        THEORY: "/Demos/Theory",
    },

    // Other pages
    SPOTIFY: "/Spotify",
    FEEDBACK: "/feedback",
} as const;

// Helper to get all drill routes as an array for nav items
export const DRILL_NAV_ITEMS: readonly NavigationItem[] = [
    { label: "Intervals Drill", to: ROUTES.DRILL.INTERVALS },
    { label: "Chords Drill", to: ROUTES.DRILL.CHORDS },
    { label: "Progressions Drill", to: ROUTES.DRILL.PROGRESSIONS },
    { label: "Melodies Drill", to: ROUTES.DRILL.MELODIES },
] as const;

// Helper to get all learn routes for dropdown
export const LEARN_NAV_ITEMS: readonly NavigationItem[] = [
    { label: "Start Here", to: ROUTES.LEARN.START_HERE },
    { label: "Intervals", to: ROUTES.LEARN.INTERVALS },
    { label: "Chords", to: ROUTES.LEARN.CHORDS },
    { label: "Progressions", to: ROUTES.LEARN.PROGRESSIONS },
    { label: "Melodies", to: ROUTES.LEARN.MELODIES },
] as const;

// Helper to get demo routes for nav
export const DEMO_NAV_ITEMS: readonly NavigationItem[] = [
    { label: "Sound", to: ROUTES.DEMOS.SOUND },
    // Temporarily removed for initial launch
    // { label: "Theory", to: ROUTES.DEMOS.THEORY },
] as const;
